import BillingsOrderTaxiRailyRecalculateParams, {
  BillingsOrderTaxiRailyRecalculateParamsBillingNode,
} from "../../../../../common/services/billings/order/taxi-raily/recalculate/billings-order-taxi-raily-recalculate-params";
import BillingsNode from "../../../common/types/billings-node";
import BillingFormData from "../types/billing-form.data";

const createRecalculateLoadParamsBillingNode = (
  node: BillingsNode,
): BillingsOrderTaxiRailyRecalculateParamsBillingNode => {
  return {
    id: node.id,
    nodeId: node.nodeId,
    orderId: node.orderId,
    lat: node.lat,
    lon: node.lon,
    distance: node.distance,
    description: node.description,
    checkoutDate: node.checkoutDate,
    checkoutEventId: node.checkoutEventUuid,
    plannedDate: node.plannedDate,
    haltingTime: node.haltingTime,
    allowCharge: node.isHighwayAllowed,
    highwayCharge: node.highwayCharge,
    plannedDistance: node.plannedDistance,
    editableCoordinates: node.isEditable,
  };
};

const createRecalculateLoadParamsBillingNodes = (
  nodes: BillingsNode[],
): BillingsOrderTaxiRailyRecalculateParamsBillingNode[] => {
  return nodes.map(createRecalculateLoadParamsBillingNode);
};

const createRecalculateLoadParams = (
  data: BillingFormData,
): BillingsOrderTaxiRailyRecalculateParams => {
  return {
    billingNodes: createRecalculateLoadParamsBillingNodes(data.billingNodes),
    billingType: "PUB_CARGO_2_RAILY",
    discount: data.discount,
    orderId: data.cargoOrderId,
  };
};

const billingRecalculateLoadParamsFactory = {
  createRecalculateLoadParams,
};

export default billingRecalculateLoadParamsFactory;
